import React, {useState, useEffect} from "react";
import SignalsService from "../../services/Signals";
import {
    FaArrowLeft,
    FaShare,
    FaChartLine,
    FaHeart,
    FaComment,
    FaSignal,
    FaTrophy,
    FaCheck,
    FaStar,
    FaUsers,
    FaLock,
} from "react-icons/fa";

import {FaTimes} from "react-icons/fa";
import {
    motion,
    useMotionValue,
    animate,
    AnimatePresence,
} from "framer-motion";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router-dom";
import ProfileService from "../../services/Profile";

export default function PackageDetails() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    const [signalTab, setSignalTab] = useState(false);
    const [signals, setSignals] = useState([]);
    const [packageDetail, setPackageDetail] = useState(null);


    const formatPrice = (num) => {
        if (!num || num === 0) return "0";
        return num.toLocaleString("en-US");
    };

    const {id} = useParams();

    async function clickOnSingal(s) {

        try {
            const response = await SignalsService.getSignalById(s._id);
            console.log(response);
                navigate(`/signal/${s._id}`);
        } catch (error) {
            console.error("Failed to fetch signal details:", error);
        }
    }

    useEffect(() => {
        const getPackageDetail = async () => {
            const params = {
                package: id,
                // isPremium: false
            };
            console.log("params", params);
            try {
                const res = await ProfileService.getPackageById(id);
                setPackageDetail(res?.data?.data);
            } catch (err) {
                console.error("Failed to fetch signals", err);
            }
        };
        getPackageDetail();
    }, [id]);

    useEffect(() => {
        const getSignals = async () => {
            const params = {
                package: id,
            };
            try {
                const res = await SignalsService.getAll(params);
                setSignals(res?.data?.data);
                console.log("Signals for package::::", res);
            } catch (err) {
                console.error("Failed to fetch signals", err);
            }
        };
        getSignals();
    }, [id]);

    // function toggleDetails() {
    //     setOpenDetails((s) => !s);
    // }

    const [viewAllSignals, setViewAllSignals] = useState(false);

    const onViewAllSignals = () => {
        setViewAllSignals(true);
    };

    const y = useMotionValue(0);

    const handleCloseClick = () => {
        animate(y, 500, {duration: 0.4, ease: "easeInOut"});
        setTimeout(() => setViewAllSignals(false), 400);
    };

    const handleDragEnd = (event, info) => {
        const swipeThreshold = 50;
        const velocity = info.velocity.y;

        if (info.offset.y > swipeThreshold || velocity > 500) {
            animate(y, 500, {duration: 0.3, ease: "easeInOut"});
            setTimeout(() => setViewAllSignals(false), 300);
        } else {
            animate(y, 0, {duration: 0.2, ease: "easeOut"});
        }
    };

    const handleSubscribe = async () => {
        const body = {packageId: id};
        console.log("Subscription body:", body);
        try {
            const res = await SignalsService.subscribePackageSignal(body);
            console.log("Subscription response:", res);
        } catch (err) {
            console.error("Subscription failed:", err);
        }
    };

    const getTimeAgo = (createdAt) => {
        const now = new Date();
        const created = new Date(createdAt);

        const diff = now - created;

        const minutes = Math.floor(diff / (1000 * 60));
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const weeks = Math.floor(days / 7);

        if (minutes < 60) {
            return `${minutes} minutes ago`;
        }

        if (hours < 24) {
            return `${hours} hours ago`;
        }

        if (days < 30) {
            return `${days} days ago`;
        }

        return `${weeks} weeks ago`;
    };

    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            {/* Header */}
            <header className="bg-white px-4 py-4 fixed top-0 left-0 right-0 shadow-sm z-50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={goBack}
                            className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
                        >
                            <FaArrowLeft className="text-gray-600"/>
                        </button>
                        <h1 className="text-xl font-bold text-gray-900">Golden Package</h1>
                    </div>
                    <button
                        className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
                        <FaShare className="text-gray-600"/>
                    </button>
                </div>
            </header>

            <main className="pt-20 pb-24">
                <motion.div
                    initial={{opacity: 0, y: 24}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.4}}
                    className="w-full px-4 space-y-6"
                >
                    {/* Hero */}
                    <section>
                        <div
                            className="bg-gradient-to-br from-primary to-purple-500 rounded-2xl p-6 text-white relative overflow-hidden">
                            <div
                                className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                            <div
                                className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
                            <div className="relative z-10">
                                <div className="flex items-center space-x-3 mb-4">
                                    <FaChartLine className="text-4xl"/>
                                    <div>
                                        <h2 className="text-2xl font-bold">
                                            {packageDetail?.name}
                                        </h2>
                                        <p className="text-white/80">
                                            {packageDetail?.description}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-4">
                                        <div className="flex items-center space-x-1">
                                            <FaHeart className="text-white/80"/>
                                            <span className="text-white/90">
                        {packageDetail?.likeCount}
                      </span>
                                        </div>
                                        <div className="flex items-center space-x-1">
                                            <FaComment className="text-white/80"/>
                                            <span className="text-white/90">
                        {packageDetail?.commentCount}
                      </span>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-3xl font-bold">
                                            {formatPrice(packageDetail?.price)} USDT
                                        </p>
                                        <p className="text-white/80 text-sm">
                                            {packageDetail?.duration?.days} Days{" "}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Stats */}
                    <section>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
                                <div className="flex items-center justify-center mb-2">
                                    <FaSignal className="text-primary text-2xl"/>
                                </div>
                                <p className="text-2xl font-bold text-gray-900">0</p>
                                <p className="text-xs text-gray-500">Signals/Month</p>
                            </div>
                            <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
                                <div className="flex items-center justify-center mb-2">
                                    <FaChartLine className="text-green-500 text-2xl"/>
                                </div>
                                <p className="text-2xl font-bold text-green-600">0%</p>
                                <p className="text-xs text-gray-500">Monthly Profit</p>
                            </div>
                            <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
                                <div className="flex items-center justify-center mb-2">
                                    <FaTrophy className="text-yellow-500 text-2xl"/>
                                </div>
                                <p className="text-2xl font-bold text-gray-900">0%</p>
                                <p className="text-xs text-gray-500">Success Rate</p>
                            </div>
                        </div>
                    </section>

                    {/* Creator */}
                    <section>
                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center space-x-4">
                                <img
                                    className="w-16 h-16 rounded-full border-2 border-gray-200"
                                    src={`https://api.7-trade.ir${packageDetail?.user?.imageId?.path}`}
                                    alt={packageDetail?.user?.fullName || "Creator Image"}
                                />
                                <div className="flex-grow">
                                    <h3 className="font-bold text-lg text-gray-900">
                                        {packageDetail?.user?.fullName}
                                    </h3>
                                    <p className="text-gray-600">Senior Analyst</p>
                                    <div className="flex items-center space-x-4 mt-2">
                                        <div className="flex items-center space-x-1">
                                            <FaStar className="text-yellow-500 text-sm"/>
                                            <span className="text-sm text-gray-600">4.8</span>
                                        </div>
                                        <div className="flex items-center space-x-1">
                                            <FaUsers className="text-indigo-500 text-sm"/>
                                            <span className="text-sm text-gray-600">
                        2.1k followers
                      </span>
                                        </div>
                                    </div>
                                </div>
                                {/* <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors">
                                    Follow
                                </button> */}
                            </div>
                        </div>
                    </section>

                    {/* Description */}
                    <section>
                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                            <h3 className="font-bold text-lg mb-3">Package Description</h3>
                            <p className="text-gray-600 leading-relaxed">
                                {packageDetail?.description}
                            </p>
                            <div className="mt-4 flex flex-wrap gap-2">
                <span className="bg-indigo-100 text-indigo-600 px-3 py-1 rounded-full text-sm">
                  {packageDetail?.packageBadge}
                </span>
                            </div>
                        </div>
                    </section>

                    {/* Signals (Tabs) */}
                    <section>
                        <div className="package-details border-t border-gray-100 pt-4 mt-4">
                            <div className="flex items-center justify-between mb-3">
                                <h4 className="font-semibold text-gray-900">Recent Signals</h4>

                                <button
                                    onClick={() => navigate("/createSignal")}
                                    className="text-sm text-primary font-medium"
                                >
                                    Add Signal
                                </button>
                            </div>

                            {/* Signal Tabs */}
                            <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-4">
                                <button
                                    onClick={() => setSignalTab(false)}
                                    className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all duration-300 ${
                                        !signalTab
                                            ? "bg-white text-blue-600 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    Free Signals
                                </button>

                                <button
                                    onClick={() => setSignalTab(true)}
                                    className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all duration-300 ${
                                        signalTab
                                            ? "bg-white text-blue-600 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    Premium Signals
                                </button>
                            </div>

                            <AnimatePresence mode="wait">
                                {signalTab ? (
                                    <motion.div
                                        key="premium"
                                        initial={{opacity: 0, y: -35, scale: 0.98}}
                                        animate={{opacity: 1, y: 0, scale: 1}}
                                        exit={{opacity: 0, y: -20, scale: 0.98}}
                                        transition={{
                                            type: "spring",
                                            stiffness: 260,
                                            damping: 24,
                                        }}
                                        className="bg-gray-100 rounded-2xl py-10 px-6 text-center mb-4"
                                    >
                                        <div className="flex justify-center mb-5">
                                            <div
                                                className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
                                                <FaLock className="text-4xl text-gray-500"/>
                                            </div>
                                        </div>

                                        <h3 className="text-2xl font-bold text-gray-900">
                                            Subscribe to unlock
                                        </h3>

                                        <p className="mt-3 text-gray-500 text-lg">
                                            Get access to all premium signals
                                        </p>
                                    </motion.div>
                                ) : (
                                    <motion.div
                                        key="freeSignals"
                                        initial={{opacity: 0, y: -25}}
                                        animate={{opacity: 1, y: 0}}
                                        exit={{opacity: 0, y: -20}}
                                        transition={{
                                            duration: 0.35,
                                            ease: "easeOut",
                                        }}
                                        className="space-y-3"
                                    >
                                        {signals
                                            .filter((s) => !s?.isPremium)
                                            .map((s, idx) => (
                                                <div
                                                    key={`${s?.isPremium}-${idx}`}
                                                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
                                                    onClick={() => clickOnSingal(s)}
                                                >
                                                    <div className="flex items-center space-x-3">
                                                        <div
                                                            className="w-10 h-10 rounded-lg flex items-center justify-center">
                                                            <img
                                                                src={`https://api.7-trade.ir${s?.image?.path}`}
                                                                alt={s.title}
                                                            />
                                                        </div>

                                                        <div>
                                                            <p className="font-bold text-gray-900">
                                                                {s?.symbol?.symbol} • {s.symbol?.name}
                                                            </p>

                                                            <p className="font-bold text-sm text-gray-800">
                                                                {s?.type === "sell"
                                                                    ? "SELL"
                                                                    : s?.type === "buy"
                                                                        ? "BUY"
                                                                        : "HOLD"}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="text-right">
                                                        <p
                                                            className={`font-semibold ${
                                                                s?.delta === "Pending"
                                                                    ? "text-green-500"
                                                                    : "text-gray-500"
                                                            }`}
                                                        >
                                                            {s?.delta || "Pending"}
                                                        </p>

                                                        <p>
                                                            {getTimeAgo(s.createdAt)}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                    </motion.div>
                                )}
                            </AnimatePresence>

                            <button
                                onClick={() => onViewAllSignals(signals)}
                                className="w-full mt-3 py-2 text-sm text-primary font-medium border border-primary/20 rounded-lg hover:bg-primary/5 transition-colors"
                            >
                                View All Signals ({signals.length})
                            </button>
                        </div>
                    </section>

                    {/* Features */}
                    <section>
                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                            <h3 className="font-bold text-lg mb-4">Package Features</h3>
                            <div className="space-y-3">
                                {packageDetail?.packageFeatures.map((f, i) => (
                                    <div key={i} className="flex items-center space-x-3">
                                        <FaCheck className="text-green-500"/>
                                        <span className="text-gray-700">{f}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-40">
                        <div className="flex items-center space-x-4">
                            <div className="flex-grow">
                                <p className="text-xl font-bold text-gray-900">
                                    {formatPrice(packageDetail?.price)} USDT
                                </p>
                                <p className="text-sm text-gray-500">
                                    {packageDetail?.duration?.days}{" "}
                                    <span>Days</span>{" "}
                                </p>
                            </div>
                            <button
                                onClick={() => handleSubscribe()}
                                className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary/90 transition-colors"
                            >
                                Subscribe Now
                            </button>
                        </div>
                    </div>
                </motion.div>
            </main>
            {viewAllSignals && (
                <div className="fixed inset-0 bg-black/50 popup-overlay z-50 flex items-end min-h-screen w-full">
                    <motion.div
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.2}}
                        onClick={() => handleCloseClick()}
                    >
                        <motion.div
                            drag="y"
                            dragElastic={0.1}
                            dragConstraints={{top: 0, bottom: 0}}
                            dragMomentum={true}
                            onDragEnd={handleDragEnd}
                            style={{y}}
                            initial={{y: 500}}
                            animate={{y: 0}}
                            exit={{y: 500}}
                            transition={{type: "spring", damping: 30, stiffness: 300}}
                            className="absolute bottom-0 left-0 right-0 flex items-end justify-center z-50"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="bg-white rounded-t-3xl w-full max-h-[85vh] shadow-2xl">
                                {" "}
                                <div
                                    className="p-4 border-b border-gray-100 flex items-center justify-between sticky top-0 bg-white rounded-t-3xl">
                                    <div className="flex-1 flex justify-center">
                                        <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
                                    </div>
                                    <h3 className="text-lg font-bold text-gray-900 absolute left-4">
                                        All Signals
                                    </h3>
                                    <button
                                        onClick={() => handleCloseClick()}
                                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
                                    >
                                        <FaTimes className="text-gray-600"/>
                                    </button>
                                </div>
                                <div className="overflow-y-auto max-h-[calc(85vh-60px)] p-4">
                                    <div className="space-y-3">
                                        {signals.length === 0 && (
                                            <p className="text-sm text-gray-500 text-center py-6">
                                                No signals available
                                            </p>
                                        )}
                                        {signals.map((s, idx) => (
                                            <div
                                                key={`${s?._id}-${idx}`}
                                                onClick={() => {
                                                    clickOnSingal(s);
                                                }}
                                                className={`flex cursor-pointer items-center justify-between p-3 bg-gray-50 rounded-lg`}
                                            >
                                                <div className="flex items-center space-x-3 flex-1">
                                                    <div
                                                        className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`}
                                                    >
                                                        <img
                                                            src={`https://api.7-trade.ir/${s?.image?.path}`}
                                                            alt={s.description}
                                                            className="w-full h-full object-cover rounded-lg"
                                                        />
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <p className="font-bold text-gray-900">
                                                            {s?.symbol?.symbol} • {s.symbol?.name}
                                                        </p>

                                                        <p className="font-bold text-sm text-gray-800">
                                                            {s?.type === "sell"
                                                                ? "SELL"
                                                                : s?.type === "buy"
                                                                    ? "BUY"
                                                                    : "HOLD"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="flex gap-3 justify-center items-center flex-shrink-0 ml-3">
                                                    <div className="text-right">
                                                        <p
                                                            className={`font-semibold text-sm ${s?.delta === "Pending" ? "text-green-500" : "text-gray-500"}`}
                                                        >
                                                            {s?.delta ? s?.delta : "Pending"}
                                                        </p>
                                                        <p>
                                                            {getTimeAgo(s.createdAt)}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            )}
        </div>
    );
}

// function SignalMenu({id, activeMenuId, setActiveMenuId}) {
//     const ref = React.useRef(null);
//
//     React.useEffect(() => {
//         function onDoc(e) {
//             if (ref.current && !ref.current.contains(e.target)) {
//                 setActiveMenuId(null);
//             }
//         }
//
//         document.addEventListener("click", onDoc);
//         return () => document.removeEventListener("click", onDoc);
//     }, [setActiveMenuId]);
//
//     const isOpen = activeMenuId === id;
//
//     return (
//         <div className="relative" ref={ref}>
//             <button
//                 onClick={(e) => {
//                     e.stopPropagation();
//                     setActiveMenuId(isOpen ? null : id);
//                 }}
//                 className="w-8 h-8 flex items-center justify-center rounded-lg bg-white hover:bg-gray-100"
//             >
//                 <FaEllipsisVertical className="text-gray-600"/>
//             </button>
//
//             {isOpen && (
//                 <div
//                     className="absolute right-10 -top-8 w-36 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50">
//                     <button
//                         onClick={() => {
//                             console.log("edit signal", id);
//                             setActiveMenuId(null);
//                         }}
//                         className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3"
//                     >
//                         <FaEdit className="text-blue-500 w-4"/>
//                         <span className="text-gray-700">Edit</span>
//                     </button>
//                     <button
//                         onClick={() => {
//                             console.log("delete signal", id);
//                             setActiveMenuId(null);
//                         }}
//                         className="w-full px-4 py-2 text-left hover:bg-red-50 flex items-center space-x-3"
//                     >
//                         <FaTrash className="text-red-500 w-4"/>
//                         <span className="text-red-600">Delete</span>
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// }
